export default "__VITE_ASSET__1d5e7fb7__"